<template>
    <div class="card card-custom gutter-b">
        <div class="card-header border-0 py-6 d-flex align-items-center justify-content-between">
            <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">لیست اعلان‌های ارسالی</span>
                <span class="text-muted mt-3 font-weight-bold font-size-sm">
                    {{ pagination.total || 0 }} اعلان ثبت شده
                </span>
            </h3>
            <router-link :to="{ name: 'admin-notifications-create' }" class="btn btn-primary font-weight-bolder">
                <i class="flaticon2-plus icon-md mr-2"></i>
                افزودن اعلان جدید
            </router-link>
        </div>

        <div class="card-body pt-0">
            <div class="table-responsive">
                <table class="table table-head-custom table-vertical-center table-head-bg table-borderless">
                    <thead>
                        <tr class="text-left text-uppercase">
                            <th style="min-width: 250px">عنوان و وضعیت</th>
                            <th style="min-width: 100px">نوع</th>
                            <th style="min-width: 180px">کاربر</th>
                            <th style="min-width: 120px">درایور</th>
                            <th style="min-width: 300px">متن پیام</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="notif in notifications" :key="notif.id">
                            <td>
                                <div class="d-flex align-items-center">
                                    <div class="position-relative">
                                        <span class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                            {{ notif.title || '—' }}
                                        </span>
                                        <div v-if="notif.seen_at" class="d-flex align-items-center mt-2 font-size-sm">
                                            <svg width="19" height="19" viewBox="0 0 256 256"
                                                class="mr-2 flex-shrink-0">
                                                <path
                                                    d="M149.61,85.71l-89.6,88a8,8,0,0,1-11.22,0L10.39,136a8,8,0,1,1,11.22-11.41L54.4,156.79l84-82.5a8,8,0,1,1,11.22,11.42Z"
                                                    fill="#4F46E5" />
                                                <path
                                                    d="M245.71,74.39a8,8,0,0,0-11.32-.1l-84,82.5-18.83-18.5a8,8,0,0,0-11.21,11.42l24.43,24a8,8,0,0,0,11.22,0l89.6-88A8,8,0,0,0,245.71,74.39Z"
                                                    fill="#4F46E5" />
                                            </svg>
                                            <span class="text-primary font-weight-bold">
                                                خوانده شده در {{ formatDate(notif.seen_at) }}
                                            </span>
                                        </div>

                                        <div v-else class="d-flex align-items-center mt-2 font-size-sm text-muted">
                                            <i class="far fa-clock mr-2"></i>
                                            {{ formatDate(notif.created_at) }}
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td>
                                <span class="label label-lg label-inline font-weight-bold py-4"
                                    :class="typeClass(notif.type)">
                                    {{ typeLabel(notif.type) }}
                                </span>
                            </td>

                            <td>
                                <span v-if="notif.is_public" class="label label-light-primary label-inline font-weight-bold">
                                    عمومی
                                </span>
                                <div v-else-if="notif.notifiable">
                                    <router-link :to="{ name: 'admin-users-show', params: { id: notif.notifiable.id } }"
                                        class="text-primary font-weight-bold">
                                        {{ notif.notifiable.first_name }} {{ notif.notifiable.last_name }}
                                    </router-link>
                                    <span class="text-muted d-block font-size-sm">
                                        {{ notif.notifiable.cellphone }}
                                    </span>
                                </div>
                                <span v-else class="text-muted">—</span>
                            </td>

                            <td>
                                <span class="label label-light label-inline font-weight-bold">
                                    {{ driverLabel(notif.driver) }}
                                </span>
                            </td>

                            <td class="text-muted font-size-sm">
                                <div class="text-truncate" style="max-width: 300px;" :title="notif.message"
                                    v-b-tooltip.hover.top>
                                    {{ notif.message.length > 70 ? notif.message.substring(0, 67) + '...' :
                                        notif.message }}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="notifications.length === 0" class="text-center py-12">
                    <i class="flaticon2-bell-4 icon-4x text-muted mb-4"></i>
                    <p class="text-muted font-size-lg">هیچ اعلانی ارسال نشده است</p>
                </div>
            </div>

            <b-pagination v-if="(pagination.last_page || 0) > 1" v-model="currentPage"
                :total-rows="pagination.total || 0" :per-page="pagination.per_page || 15" align="center" class="mt-8"
                @change="fetchList"></b-pagination>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_ADMIN_NOTIFICATIONS } from "@/core/services/store/admin/notifications.module";

export default {
    name: "AdminNotificationsIndex",

    computed: {
        ...mapGetters(["adminNotifications", "adminNotificationsPagination"]),

        notifications() { return this.adminNotifications || []; },
        pagination() { return this.adminNotificationsPagination || {}; },

        currentPage: {
            get() { return this.adminNotificationsPagination?.current_page || 1; },
            set(val) { this.fetchList(val); }
        }
    },

    mounted() {
        this.fetchList();
    },

    methods: {
        fetchList(page = null) {
            const payload = page ? { page } : {};
            this.$store.dispatch(FETCH_ADMIN_NOTIFICATIONS, payload);
        },

        formatDate(date) {
            return new Date(date).toLocaleString("fa-IR", {
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            });
        },

        typeLabel(type) {
            const map = {
                success: "موفقیت",
                info: "اطلاع‌رسانی",
                warning: "هشدار",
                error: "خطا",
                message: "پیام"
            };
            return map[type] || type || "نامشخص";
        },

        typeClass(type) {
            const map = {
                success: "label-light-success",
                info: "label-light-info",
                warning: "label-light-warning",
                error: "label-light-danger",
                message: "label-light-primary"
            };
            return map[type] || "label-light-primary";
        },

        driverLabel(driver) {
            const map = {
                "App\\Services\\Notification\\drivers\\SystemNotification": "سیستم",
                "database": "دیتابیس",
                "sms": "پیامک",
                "push": "نوتیفیکیشن",
                "telegram": "تلگرام"
            };
            return map[driver] || driver || "نامشخص";
        }
    }
};
</script>

<style scoped>
.text-truncate {
    cursor: help;
}

.pulse-primary {
    animation: pulse-animation 2s infinite;
}

@keyframes pulse-animation {
    0% {
        box-shadow: 0 0 0 0 rgba(79, 70, 229, 0.7);
    }

    70% {
        box-shadow: 0 0 0 10px rgba(79, 70, 229, 0);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(79, 70, 229, 0);
    }
}
</style>